import type { ReactNode } from "react";

/** Design `List`: inset grouped list on glass (`fill` ground inside a sheet). */
export function List({ children, label }: { children: ReactNode; label?: string }) {
  return (
    <ul className="ds-list ds-list--on-glass" aria-label={label}>
      {children}
    </ul>
  );
}

interface RowProps {
  title: ReactNode;
  value?: ReactNode;
  /** Icon tile tone: ocean for spot facts, lake for objects, warning for restrictions. */
  tone?: "ocean" | "lake" | "warning";
  icon?: ReactNode;
  depth?: boolean;
  valueLabel?: string;
  /** A full-width block under the row (e.g. sightings of an object). */
  extra?: ReactNode;
}

const TONE = {
  ocean: "bg-ocean-tint text-ocean-on-tint",
  lake: "bg-lake-tint text-lake-on-tint",
  warning: "bg-warning-tint text-warning-on-tint",
} as const;

export function Row({ title, value, tone = "ocean", icon, depth, valueLabel, extra }: RowProps) {
  return (
    <li className={extra ? "ds-row ds-row--extra" : "ds-row"}>
      {icon ? (
        <span className={`ds-row__icon ${TONE[tone]}`} aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <span className="ds-row__title">{title}</span>
      {value !== undefined ? (
        <span
          className={depth ? "ds-row__value ds-row__value--depth" : "ds-row__value"}
          aria-label={valueLabel}
        >
          {value}
        </span>
      ) : null}
      {extra ? <div className="ds-row__extra">{extra}</div> : null}
    </li>
  );
}
